import {memo} from 'react'

import EditSettingsForm from '../../../../../components/EditSettingsForm/EditSettingsForm'

import usePipelineSecretForm from './PipelineSecretForm.hooks'

import styles from './PipelineSecretForm.css'

import Input, {Size} from 'src/components/pages/PipelinesPages/components/Input'

type Props = {
  onConfirm: (name: string, value: string) => void
  onDelete?: () => void
  name?: string
  helperText?: string
  isEditMode?: boolean
}
function PipelineSecretForm({
  name = '',
  isEditMode = false,
  helperText,
  onConfirm,
  onDelete,
}: Props) {
  const {
    handlerConfirmClick,
    handlerKeyPressClick,
    handlerSecretNameInputChange,
    handlerSecretValueInputChange,
    isFormInvalid,
    secretNameErrorMessage,
    secretValueErrorMessage,
    secretName,
    secretValue,
    isAddSecureTokenLoading,
  } = usePipelineSecretForm(isEditMode, name, onConfirm)

  return (
    <EditSettingsForm
      settingsClassName={styles.pipelineSecretForm}
      onConfirmClick={handlerConfirmClick}
      onDeleteClick={onDelete}
      loader={isAddSecureTokenLoading}
      disabled={Boolean(isAddSecureTokenLoading || isFormInvalid)}
      title={`${isEditMode ? 'Edit' : 'Add New'} Secret`}
    >
      <div className={styles.pipelineSecretWrapForm}>
        <div className={styles.pipelineSecretFormInput}>
          <Input
            placeholder={'Secret Name'}
            onChange={handlerSecretNameInputChange}
            onKeyPress={handlerKeyPressClick}
            value={secretName}
            size={Size.FULL}
            aria-label="Secret Name"
            type="text"
            error={secretNameErrorMessage}
            autoComplete="off"
          />
        </div>
        <div>{'='}</div>
        <div className={styles.pipelineSecretFormInput}>
          <Input
            placeholder={'Value'}
            onKeyPress={handlerKeyPressClick}
            onChange={handlerSecretValueInputChange}
            value={secretValue}
            size={Size.FULL}
            aria-label="Value"
            data-imitate-password
            error={secretValueErrorMessage}
            autoComplete="off"
          />
        </div>
      </div>
      {helperText && <div className={styles.pipelineSecretFormHelperText}>{helperText}</div>}
    </EditSettingsForm>
  )
}

export default memo(PipelineSecretForm)
